import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { intlShape } from 'react-intl'
import * as shapes from '../../constant/shapes'
import MiniPlayer from '../miniPlayer/MiniPlayer'
import * as selectors from '../miniPlayer/miniPlayerSelectors'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import { open as openAction } from '../miniPlayer/miniPlayerActions'
import { pause as pauseAction, play as playAction } from '../miniPlayer/AudioPlayer/playerActions'
import { checkMobileTablet } from '../../utils/testMobile'
import GTMController from "../../utils/kpi/GTMController"


const TrackItem  = (props) => {
	const {
		fields,
		track,
		index,
		GTMPlayEvent
	} = props

	return (
		<div className="track__items">
			{fields.map((field, key) => (
				<span
					key={`trackitem-${track.id}-${key}`}
					className={`track__item track__item--${field.type} ${track.parental_warning ? 'explicit' : ''} ${key !== 0 && 'text-overflow'}`}
				>
					{field.render(track, index)}
					{key === 0 && <MiniPlayer
						element={track}
						buttonClassName="track__player"
						type={ORIGIN_PLAYQUEUE_TYPES.track}
						sampleable={track.sampleable}
						GTMPlayEvent={GTMPlayEvent}
					/>}
				</span>
			))}
		</div>
	)
}

TrackItem.propTypes = {
	fields: PropTypes.arrayOf(PropTypes.shape({
		type: PropTypes.string,
		render: PropTypes.func
	})).isRequired,
	track: shapes.trackItem.isRequired,
	idCurrentTrack: PropTypes.number,
	index: PropTypes.number,
	GTMPlayEvent: PropTypes.string
}

TrackItem.contextTypes = {
	intl: intlShape
}

const mapStateToProps = state => ({
	idCurrentTrack: selectors.getIdCurrentTrack(state),
	playing: selectors.isPlaying(state),
	isCurrentTrack: (type, idElement) => selectors.isCurrentTrack(state)(type, idElement)
})

export default connect(mapStateToProps)(TrackItem)



// WEBPACK FOOTER //
// ./src/components/tracklist/TrackItem.jsx